export const menuData = [
  {
    label: "Types de coaching",
    href: "/coachingtypes",
    children: [
      {
        heading: "Nutrition",
        submenu: [
          { label: "Le coaching", href: "/coachingtypes/coachingnutrition" },
        ],
      },
      {
        heading: "Musculation",
        submenu: [
          { label: "Le coaching", href: "/coachingtypes/coachingmusculation" },
        ],
      },
      {
        heading: "Nutrition + Musculation",
        submenu: [
          { label: "Le coaching", href: "/coachingtypes/coachingmuscunutri" },
        ],
      },
    ],
  },
  {
    label: "Coach",
    href: "/coach",
  },
  { label: "Ebooks", href: "/ebook" },
  { label: "Me contacter", href: "/contact" },
];

export const menuDataAdmin = [
  {
    label: "Clients",
    href: "/clients",
    children: [
      {
        heading: "Clients",
        submenu: [
          {
            label: "Liste des clients",
            href: "/clients",
          },
          {
            label: "Ajouter un client",
            href: "/newclient",
          },
        ],
      },
      {
        heading: "Nutrition",
        submenu: [
          {
            label: "Creation nutrition new client",
            href: "/nutritioncalculation",
          },
        ],
      },
    ],
  },
  {
    label: "Fitness",
    href: "/exerciseintensity",
    children: [
      {
        heading: "Core Exercises",
        submenu: [
          {
            label: "Exercise creation",
            href: "/exercisecreation",
          },
          {
            label: "Muscle Group creation",
            href: "/musclecreation",
          },
          {
            label: "Equipment creation",
            href: "/equipmentcreation",
          },
        ],
      },
      {
        heading: "Display",
        submenu: [
          {
            label: "Liste des exercises",
            href: "/exerciselisting",
          },
          {
            label: "Exercises Intensity",
            href: "/exerciseintensity",
          },
        ],
      },
    ],
  },
  {
    label: "Consulting",
    href: "/advicenutrition",
    children: [
      {
        heading: "Nutrition",
        submenu: [
          {
            label: "Advice nutrition",
            href: "/advicenutrition",
          },
        ],
      },
    ],
  },
  {
    label: "Recettes",
    href: "/newrecipe",
    children: [
      {
        heading: "Recettes",
        submenu: [
          {
            label: "Liste des recettes",
            href: "/recettes",
          },
          {
            label: "Création d'une nouvelle recette",
            href: "/newrecipe",
          },
        ],
      },
    ],
  },
];

export const menuDataUser = (id) => [
  {
    label: "Tableau de bord",
    href: `/dashboard/${id}`,
  },
  {
    label: "Check-in",
    href: `/weeklycheckinform/${id}`,
    children: [
      {
        heading: "Par jour",
        submenu: [
          {
            label: "Ajout du poids",
            href: `/weightupdate/${id}`,
          },
        ],
      },
      {
        heading: "Par semaine",
        submenu: [
          {
            label: "Check-in",
            href: `/weeklycheckinform/${id}`,
          },
        ],
      },
      {
        heading: "Documentation",
        submenu: [
          {
            label: "Comment remplir le check-in?",
            href: "/documents/commentremplirlecheckin",
          },
          {
            label: "Les manières de traquer son progrès",
            href: "/documents/traquersonprogres",
          },
        ],
      },
    ],
  },
  {
    label: "Nutrition",
    href: "#",
    children: [
      {
        heading: "Tips",
        submenu: [
          {
            label: "Liste des protéines, lipides et glucides",
            href: "/documents/listedesmacronutrients",
          },
          {
            label: "Comment manger plus de protéinés au quotidien?",
            href: "#",
          },
          {
            label: "Exemples de desserts protéinés",
            href: "/documents/dessertsproteines",
          },
          {
            label: "Idées de petits-déjeuners et de collations",
            href: "#",
          },
        ],
      },
      {
        heading: "Fiches techniques",
        submenu: [
          {
            label: "Gérer un buffet à volonter",
            href: "#",
          },
          {
            label: "Gérer un repas de famille",
            href: "#",
          },
          {
            label: "Plusieurs jours en famille, comment faire?",
            href: "#",
          },
        ],
      },
    ],
  },
  {
    label: "Fitness",
    href: "#",
    children: [
      {
        heading: "Liste",
        submenu: [
          {
            label: "Liste des exercices",
            href: "/exerciselisting",
          },
        ],
      },
    ],
  },
  {
    label: "Recettes",
    href: "/recettes",
    children: [
      {
        heading: "Liste",
        submenu: [
          {
            label: "Les recettes",
            href: "/recettes",
          },
        ],
      },
    ],
  },
];
